export const GA_ASSISTANT_PERMISSION = 'GA_ASSI';

/** 운영 FCHEROS. nginx가 http를 https로 리다이렉트하므로 postMessage 출처도 https여야 한다. */
export const FCHEROS_PRODUCTION_ORIGIN = 'https://fcheros.gop.ai.kr';

const LOOPBACK_HOSTS = new Set(['localhost', '127.0.0.1', '::1']);

export function isLoopbackHost(hostname) {
  return LOOPBACK_HOSTS.has(String(hostname || '').trim().toLowerCase());
}

/**
 * 로컬·스테이징은 4000포트. 페이지가 localhost면 사설 아이피(lanHost)를 쓴다.
 * 운영은 https://fcheros.gop.ai.kr.
 * @param {string|undefined} appEnv
 * @param {string|undefined} hostname
 * @param {string|null|undefined} lanHost
 * @returns {string}
 */
export function resolveFcherosOrigin(appEnv, hostname, lanHost) {
  if (appEnv === 'production') {
    return FCHEROS_PRODUCTION_ORIGIN;
  }
  const pageHost = hostname && String(hostname).trim() ? String(hostname).trim() : 'localhost';
  const host = isLoopbackHost(pageHost) && lanHost ? String(lanHost).trim() : pageHost;
  return `http://${host}:4000`;
}

let detectedLanHost = null;
let detectPromise = null;

function rememberLanHost(host) {
  if (host && !isLoopbackHost(host)) {
    detectedLanHost = host;
  }
}

/** 브라우저가 알려 주는 사설 IPv4. 없으면 null. */
export function detectLanHost() {
  if (detectedLanHost) return Promise.resolve(detectedLanHost);
  if (detectPromise) return detectPromise;
  detectPromise = new Promise((resolve) => {
    if (typeof window === 'undefined' || typeof RTCPeerConnection === 'undefined') {
      resolve(null);
      return;
    }
    let settled = false;
    const pc = new RTCPeerConnection({ iceServers: [] });
    const finish = (ip) => {
      if (settled) return;
      settled = true;
      window.clearTimeout(timer);
      try {
        pc.close();
      } catch {
        // ignore
      }
      rememberLanHost(ip);
      resolve(ip || null);
    };
    const timer = window.setTimeout(() => finish(null), 800);
    pc.onicecandidate = (event) => {
      const candidate = event.candidate && event.candidate.candidate;
      if (!candidate) return;
      const match = candidate.match(/(\d{1,3}(?:\.\d{1,3}){3})/);
      if (!match || isLoopbackHost(match[1]) || match[1].startsWith('169.254.')) return;
      finish(match[1]);
    };
    try {
      pc.createDataChannel('lan');
      pc.createOffer()
        .then((offer) => pc.setLocalDescription(offer))
        .catch(() => finish(null));
    } catch {
      finish(null);
    }
  });
  return detectPromise;
}

export function getFcherosOrigin() {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
  if (process.env.REACT_APP_ENV !== 'production' && isLoopbackHost(hostname)) {
    detectLanHost();
  }
  return resolveFcherosOrigin(process.env.REACT_APP_ENV, hostname, detectedLanHost);
}

/** localhost인데 사설 아이피를 아직 모르면 null. 아는 주소는 바로 반환한다. */
export function getFcherosOriginIfKnown() {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
  if (process.env.REACT_APP_ENV !== 'production' && isLoopbackHost(hostname) && !detectedLanHost) {
    detectLanHost();
    return null;
  }
  return getFcherosOrigin();
}

/** 창을 열기 직전 주소. localhost면 사설 아이피를 먼저 찾는다. */
export async function resolveFcherosOriginForLaunch() {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
  if (process.env.REACT_APP_ENV === 'production' || !isLoopbackHost(hostname)) {
    return resolveFcherosOrigin(process.env.REACT_APP_ENV, hostname);
  }
  const lanHost = await detectLanHost();
  return resolveFcherosOrigin(process.env.REACT_APP_ENV, hostname, lanHost);
}
